module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Ca-Jc.e1c75895.png";